import { Action } from 'redux';
import { connect } from 'react-redux';
import { dispatchAsync } from 'react-redux-dispatch-async';
import { AppState } from 'common/configuration/app.states';
import { getStateCategories, getStateSubCategories } from 'generalContext/usecases/General.selectors';
import { GetProductsProps } from 'generalContext/domain/entities/Product';
import { getProductsRequest } from 'generalContext/usecases/General.actions';
import { SearchBoxDumb } from './SearchBox.dumb';

const mapState = (state: AppState) => ({
  stateCategories: getStateCategories(state),
  stateSubCategories: getStateSubCategories(state),
});

const mapDispatch = (dispatch: (a: Action) => void) => ({
  getProductsAsync: (props?: GetProductsProps) => dispatchAsync(dispatch, getProductsRequest(props)),
});

export const SearchBoxSmart = connect(mapState, mapDispatch)(SearchBoxDumb);
